// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","inner":"Footer_inner__fhIqU","links":"Footer_links__q2x7d"};